import React from 'react';

interface Props {
    title: string;
    value: string;
    bgColor: string;
    lineColor: string;
}
export default function ValueChart({ title, value }: Props) {
    return (
        <div className="w-full md:w-1/3 px-2">
            <div className="rounded-lg shadow-sm mb-4">
                <div className="rounded-lg bg-white shadow-lg md:shadow-xl relative overflow-hidden">
                    <div className="px-3 pt-8 pb-10 text-center relative">
                        <h4 className="text-sm uppercase text-gray-500 leading-tight">{title}</h4>
                        <h3 className="text-3xl text-gray-700 font-semibold leading-tight my-3">{value}</h3>
                        <p className="text-xs text-red-500 leading-tight"></p>
                    </div>
                </div>
            </div>
        </div>
    );
}
